import { ApplicantDocument, ApplicantDocumentDto, ApplicantDto, ApplicantSharedWithRelationsDto, ApplicantUpdateDto, apiRoutes } from "@sr-partner-portal/common";
import ky from "ky";

class Api {
    static async getDownloadUrlByShareLinkToken({
        id,
        token,
    }: {
        id: number;
        token: string;
    }) {
        const responseData = await ky
            .get<{ downloadUrl: string }>(
                apiRoutes()
                    .applicantDocuments()
                    .getDownloadUrlByShareLinkToken(false, { id })
                    .build({ token }),
            )
            .json();

        return responseData;
    }

    static async updateByShareLinkTokenAsync(
        token: string,
        applicantUpdateDto: ApplicantUpdateDto,
    ) {
        const responseData = await ky
            .put<{ applicantDto: Record<string, unknown> }>(
                apiRoutes()
                    .applicants()
                    .updateByShareLinkToken(false, { token })
                    .build(),
                {
                    json: {
                        applicantUpdateDto,
                    },
                },
            )
            .json();

        const applicantDto = ApplicantDto.createFromApplicantData(
            responseData.applicantDto,
        );
        const applicant = applicantDto.toApplicant();
        return applicant;
    }

    static async getPreviewUrlByShareLinkToken({
        id,
        token,
    }: {
        id: number;
        token: string;
    }) {
        const responseData = await ky
            .get<{ previewUrl: string }>(
                apiRoutes()
                    .applicantDocuments()
                    .getPreviewUrlByShareLinkToken(false, { id })
                    .build({ token }),
            )
            .json();

        return responseData;
    }

    static async getByShareLinkToken(token: string) {
        const responseData = await await ky
            .get<{ applicantSharedWithRelationsDto: Record<string, unknown> }>(
                apiRoutes()
                    .applicants()
                    .getByShareLinkToken(false, { token })
                    .build(),
            )
            .json();

        const applicantSharedWithRelationsDto =
            ApplicantSharedWithRelationsDto.createFromApplicantWithRelationsData(
                responseData.applicantSharedWithRelationsDto,
            );

        const applicantSharedWithRelations =
            applicantSharedWithRelationsDto.toApplicantWithRelations();
        return applicantSharedWithRelations;
    }

    static async getDocumentsByShareLinkToken(token: string) {
        const responseData = await await ky
            .get<{
                applicantDocumentDtos: Record<string, unknown>[];
            }>(
                apiRoutes()
                    .applicantDocuments()
                    .getByShareLinkToken(false, { token })
                    .build(),
            )
            .json();

        const applicantDocuments: ApplicantDocument[] =
            responseData.applicantDocumentDtos.map((xApplicantDocument) =>
                ApplicantDocumentDto.createFromApplicantDocument(
                    xApplicantDocument,
                ).toApplicantDocument(),
            );

        return applicantDocuments;
    }
}

export { Api };
